/**
 * Normalizes coordinates to 0-1 range based on width and height
 * @param {Object} point - Point {x, y}
 * @param {number} width - Canvas width
 * @param {number} height - Canvas height
 * @returns {Object} Normalized point {x, y}
 */
export const normalizeXY = ({ x, y }, width, height) => {
  return {
    x: x / width,
    y: y / height
  };
};